import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver';
import { Component } from '@angular/core';

@Component({
  selector: 'app-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrl: './upload-file-dialog.component.scss',
})
export class UploadFileDialogComponent {
  files: FileList | null = null;
  headers = [
    'Index',
    'Firstname',
    'Lastname',
    'RoleType',
    'Email',
    'PhoneNumber',
    'Address',
    'Reference',
    'IsEmployee',
    'Department',
  ];
  errorMessage: string;
  successMessage: string;

  columnDefs = this.headers.map((header) => ({
    headerName: header,
    field: header,
    editable: true,
  }));

  defaultColDef = {
    flex: 1,
    minWidth: 100,
    editable: true,
    resizable: true,
  };

  onFileDrop(event: any) {
    this.files = event.container.data.files; // Access dropped files
    console.log('Uploaded files:', this.files); // Handle file upload logic here (e.g., call an upload service)
  }
  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      this.files = target.files;
      console.log('Uploaded files (selected):', this.files); // Handle file upload logic here
    }
  }
  // downloadExcel() {
  //   const formattedHeaders = this.headers.map(this.formatHeader); // Apply formatting to headers
  //   const worksheet = XLSX.utils.json_to_sheet(this.data);
  //   XLSX.utils.sheet_add_aoa(worksheet, [formattedHeaders], { origin: 'A1' }); // Add formatted headers

  //   // Set custom column width
  //   worksheet['!cols'] = [
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 30 },
  //     { width: 15 },
  //     { width: 45 },
  //     { width: 15 },
  //   ];

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  //   XLSX.writeFile(workbook, 'org_users.xlsx'); // Replace with your desired filename
  // }
  formatHeader(header: string): XLSX.CellObject {
    return {
      v: header, // Value
      t: 's',
      s: {
        // Style
        font: { bold: true }, // Make the header bold
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: 'FFFF00' } }, // Example yellow fill
        border: { all: { style: 'thin' } },
      },
    };
  }
  onFileChange(event: any) {
    const uploadedFile = event.target.files[0];
    this.validateFile(uploadedFile);
  }
  jsonData: any = null;
  jsonTableData: any;
  readFile(file: File) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      const arrayBuffer = e.target.result;
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const sheetName = workbook.SheetNames[0]; // Assuming first sheet
      const worksheet = workbook.Sheets[sheetName];
      // Validate data in worksheet (see explanation below)
    };
  }
  validationErrors: string[] = [];
  dataRows: unknown[] = [];
  validateFile(file: File) {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });

        // Validate headers
        const headers = worksheet[0] as string[];

        const headerValidationErrors = this.validateHeaders(headers);
        if (headerValidationErrors.length > 0) {
          this.validationErrors = headerValidationErrors;
          this.errorMessage = 'Header validation failed.';
          this.successMessage = null;
          this.jsonTableData = null;
          this.jsonData = null;
          return;
        }

        // Validate data rows
        const dataRows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        this.validationErrors = this.validateData(dataRows);
        if (this.validationErrors.length === 0) {
          this.successMessage = 'File validated successfully.';
          this.errorMessage = null;
          this.jsonTableData = this.dataRows;
          this.jsonData = JSON.stringify(this.dataRows, null, 2);
        } else {
          this.errorMessage = 'File contains errors.';
        }
      };
      reader.readAsArrayBuffer(file);
    } else {
      this.errorMessage = 'Please select a file first.';
    }
  }
  validateHeaders(headers: string[]): string[] {
    const errors: string[] = [];
    if (headers.length !== this.headers.length) {
      errors.push('Incorrect number of headers.');
    } else {
      for (let i = 0; i < headers.length; i++) {
        if (headers[i] !== this.headers[i]) {
          errors.push(
            `Header mismatch at position ${i + 1}: expected "${
              this.headers[i]
            }", found "${headers[i]}"`
          );
        }
      }
    }
    return errors;
  }
  // validateData(data: any[]): string[] {
  //   const errors: string[] = [];
  //   data.forEach((row, index) => {
  //     if (
  //       !row['Index'] ||
  //       !row['Firstname'] ||
  //       !row['Lastname'] ||
  //       !row['RoleType'] ||
  //       !row['Email'] ||
  //       !row['PhoneNumber'] ||
  //       !row['Address'] ||
  //       !row['Reference']
  //     ) {
  //       errors.push(`Row ${index + 1}: Missing required fields.`);
  //     }
  //     // Add more validation rules as needed
  //   });
  //   return errors;
  // }
  validateData(data: any[]): string[] {
    const errors: string[] = [];
    data.forEach((row, index) => {
      if (row['Index']) {
        this.dataRows.push(row);
        if (
          !row['Firstname'] ||
          !row['Lastname'] ||
          !row['RoleType'] ||
          !row['PhoneNumber'] ||
          !row['Address'] ||
          !row['Reference'] ||
          !row['IsEmployee']
        ) {
          errors.push(`Row ${index + 1}: Missing required fields.`);
        }

        // Example of additional validation rules
        // Check if PhoneNumber is a valid number
        if (row['PhoneNumber'] && isNaN(row['PhoneNumber'])) {
          errors.push(`Row ${index + 1}: PhoneNumber must be a valid number.`);
        }
      }
    });
    return errors;
  }

  onCellValueChanged(event: any) {
    // This function is called when a cell value is changed
    console.log('Cell value changed:', event);
    // You can perform any additional actions here, such as updating the underlying data
  }

  onRowValueChanged(event: any) {
    // This function is called when a row value is changed
    console.log('Row value changed:', event);
    // You can perform any additional actions here, such as updating the underlying data
  }

  saveData() {
    // This function is called when the "Save Data" button is clicked
    const temp = this.jsonTableData as BulkUser[];
    console.log('Saving data...', typeof temp);
    // You can implement the logic to save the data here, for example, sending it to a backend API
  }
  async generateExcel() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Define headers
    const headers = [
      'Index',
      'Firstname',
      'Lastname',
      'RoleType',
      'Email',
      'PhoneNumber',
      'Address',
      'Reference',
      'IsEmployee',
      'Department',
    ];

    worksheet.columns = headers.map((header, index) => ({
      header,
      key: header.toLowerCase(),
      width: 20,
    }));

    for (let i = 0; i < 100; i++) {
      worksheet.addRow({
        index: '', // Continue the index from the last data index
        firstname: '',
        lastname: '',
        roletype: '',
        email: '',
        phonenumber: '',
        address: '',
        reference: '',
        isEmployee: '',
        department: '',
      });
    }

    // Set text formatting for PhoneNumber column
    worksheet.getColumn('phonenumber').numFmt = '@'; // Text format
    console.log(worksheet.getColumn('roletype'), 'immfgfg 2');
    // Apply data validation to 'RoleType' column
    const column = worksheet.getColumn('roletype');
    column.eachCell((cell, rowNumber) => {
      if (rowNumber > 1) {
        // Skip header row
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"Admin,User,Supervisor,Security,Facility,Non-User"'],
          showErrorMessage: true,
          errorTitle: 'Invalid Role',
          error: 'Please select a role from the dropdown',
        };
      }
    });
    console.log(worksheet, 'immfgfg');
    const column1 = worksheet.getColumn('isemployee');
    column1.eachCell((cell, rowNumber) => {
      if (rowNumber > 1) {
        // Skip header row
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"Yes,No"'],
          showErrorMessage: true,
          errorTitle: 'Invalid Role',
          error: 'Please select a role from the dropdown',
        };
      }
    });

    // Apply header formatting
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: 'middle',
      horizontal: 'center',
    };

    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    fs.saveAs(blob, 'ExcelSheet.xlsx');
  }
}
export interface BulkUser {
  Address: string;
  Email: string;
  Firstname: string;
  Index: number;
  Lastname: string;
  PhoneNumber: string;
  Reference: string;
  RoleType: string;
  IsEmployee: string;
  Department: string;
}
